// Liste des spécialités et professions de santé, adaptée depuis Doctolib
// (https://www.doctolib.fr/specialities). Les entrées populaires sont conservées
// en tête pour faciliter la sélection.
export const SPECIALTIES = [
  // Populaires
  "Médecin généraliste",
  "Chirurgien-dentiste",
  "Infirmier",
  "Pédiatre",
  "Ophtalmologue",
  "Dermatologue et vénérologue",
  "Ostéopathe",
  "Masseur-kinésithérapeute",
  "Opticien-lunetier",
  "Pédicure-podologue",
  "Sage-femme",
  "ORL",
  "Allergologue",
  "Chirurgien urologue",
  "Rhumatologue",
  "Stomatologue",
  "Endocrinologue",
  "Chirurgien orthopédiste et traumatologue",
  "Diététicien",
  "Psychologue",
  "Neurologue",
  "Psychiatre",
  "Radiologue",
  "Cardiologue",
  "Gastro-entérologue et hépatologue",
  // Autres (ordre alphabétique)
  "Acupuncteur",
  "Addictologue",
  "Adjoint médecin",
  "Anatomo-cyto-pathologiste",
  "Anesthésiste",
  "Angiologue",
  "Assistant de service social",
  "Audioprothésiste",
  "Auxiliaire de puériculture",
  "Biologiste des agents infectieux",
  "Biologiste moléculaire",
  "Cancérologue",
  "Cancérologue biologiste",
  "Cancérologue médical",
  "Cancérologue radiothérapeute",
  "Chercheur médical",
  "Chiropracteur",
  "Chirurgien cancérologue",
  "Chirurgien de la face et du cou",
  "Chirurgien de la main",
  "Chirurgien endocrinien",
  "Chirurgien général",
  "Chirurgien infantile",
  "Chirurgien maxillo-facial",
  "Chirurgien maxillo-facial et stomatologue",
  "Chirurgien oral",
  "Chirurgien pédiatrique",
  "Chirurgien thoracique et cardio-vasculaire",
  "Chirurgien vasculaire",
  "Chirurgien viscéral et digestif",
  "Dermatopathologue",
  "Échographiste",
  "Endocrinologue diabétologue",
  "Épithésiste",
  "Ergothérapeute",
  "Généticien",
  "Gériatre",
  "Gynécologue médical",
  "Gynécologue médical et obstétrique",
  "Gynécologue obstétricien",
  "Hématologue",
  "Hématologue biologiste",
  "Homéopathe",
  "Immunologue",
  "Infectiologue",
  "Infirmier en pratique avancée",
  "Infirmier puériculteur",
  "Manipulateur en électroradiologie médicale",
  "Médecin biologiste",
  "Médecin bucco-dentaire",
  "Médecin de la douleur",
  "Médecin de la reproduction",
  "Médecin de la reproduction et gynécologue médical",
  "Médecin de soins palliatifs",
  "Médecin du sport",
  "Médecin du travail",
  "Médecin morphologue et anti-âge",
  "Médecin nucléaire",
  "Médecin nutritionniste",
  "Médecin réanimateur",
  "Médecin spécialiste de santé publique",
  "Médecin urgentiste",
  "Médecin vasculaire",
  "Néphrologue",
  "Neurochirurgien",
  "Neuro-pathologiste",
  "Neuro-psychiatre",
  "Oculariste",
  "Onco-hématologue",
  "Oncologue médical",
  "Onco-radiothérapeute",
  "ORL - Chirurgien de la face et du cou",
  "Orthodontiste",
  "Orthopédiste-orthésiste",
  "Orthophoniste",
  "Orthoprothésiste",
  "Orthoptiste",
  "Pharmacien",
  "Phlébologue",
  "Phoniatre",
  "Pneumologue",
  "Podo-orthésiste",
  "Psychiatre de l'enfant et de l'adolescent",
  "Psychomotricien",
  "Psychothérapeute",
  "Radiothérapeute",
  "Rééducation de l'amblyopie",
  "Sage-femme échographiste",
  "Spécialiste en chirurgie plastique reconstructrice et esthétique",
  "Spécialiste en hémobiologie-transfusion",
  "Spécialiste en médecine aérospatiale",
  "Spécialiste en médecine de catastrophe",
  "Spécialiste en médecine générale",
  "Spécialiste en médecine interne",
  "Spécialiste en médecine légale et expertises médicales",
  "Spécialiste en médecine physique et de réadaptation",
  "Spécialiste en réanimation",
  "Technicien de biologie médicale",
  "Acupuncteur",
  "Addictologue",
  "Adjoint médecin",
  "Anatomo-cyto-pathologiste",
  "Anesthésiste",
  "Angiologue",
  "Assistant de service social",
  "Audioprothésiste",
  "Auxiliaire de puériculture",
  "Biologiste des agents infectieux",
  "Biologiste moléculaire",
  "Cancérologue",
  "Cancérologue biologiste",
  "Cancérologue médical",
  "Cancérologue radiothérapeute",
  "Chercheur médical",
  "Chiropracteur",
  "Chirurgien cancérologue",
  "Chirurgien de la face et du cou",
  "Chirurgien de la main",
  "Chirurgien endocrinien",
  "Chirurgien général",
  "Chirurgien infantile",
  "Chirurgien maxillo-facial",
  "Chirurgien maxillo-facial et stomatologue",
  "Chirurgien oral",
  "Chirurgien pédiatrique",
  "Chirurgien thoracique et cardio-vasculaire",
  "Chirurgien vasculaire",
  "Chirurgien viscéral et digestif",
  "Dermatopathologue",
  "Échographiste",
  "Endocrinologue diabétologue",
  "Épithésiste",
  "Ergothérapeute",
  "Généticien",
  "Gériatre",
  "Gynécologue médical",
  "Gynécologue médical et obstétrique",
  "Gynécologue obstétricien",
  "Hématologue",
  "Hématologue biologiste",
  "Homéopathe",
  "Immunologue",
  "Infectiologue",
  "Infirmier en pratique avancée",
  "Infirmier puériculteur",
  "Manipulateur en électroradiologie médicale",
  "Médecin biologiste",
  "Médecin bucco-dentaire",
  "Médecin de la douleur",
  "Médecin de la reproduction",
  "Médecin de la reproduction et gynécologue médical",
  "Médecin de soins palliatifs",
  "Médecin du sport",
  "Médecin du travail",
  "Médecin morphologue et anti-âge",
  "Médecin nucléaire",
  "Médecin nutritionniste",
  "Médecin réanimateur",
  "Médecin spécialiste de santé publique",
  "Médecin urgentiste",
  "Médecin vasculaire",
  "Néphrologue",
  "Neurochirurgien",
  "Neuro-pathologiste",
  "Neuro-psychiatre",
  "Oculariste",
  "Onco-hématologue",
  "Oncologue médical",
  "Onco-radiothérapeute",
  "ORL - Chirurgien de la face et du cou",
  "Orthodontiste",
  "Orthopédiste-orthésiste",
  "Orthophoniste",
  "Orthoprothésiste",
  "Orthoptiste",
  "Pharmacien",
  "Phlébologue",
  "Phoniatre",
  "Pneumologue",
  "Podo-orthésiste",
  "Psychiatre de l'enfant et de l'adolescent",
  "Psychomotricien",
  "Psychothérapeute",
  "Radiothérapeute",
  "Rééducation de l'amblyopie",
  "Sage-femme échographiste",
  "Spécialiste en chirurgie plastique reconstructrice et esthétique",
  "Spécialiste en hémobiologie-transfusion",
  "Spécialiste en médecine aérospatiale",
  "Spécialiste en médecine de catastrophe",
  "Spécialiste en médecine générale",
  "Spécialiste en médecine interne",
  "Spécialiste en médecine légale et expertises médicales",
  "Spécialiste en médecine physique et de réadaptation",
  "Spécialiste en réanimation",
  "Technicien de biologie médicale",
];
